import React from "react";
import styled, { keyframes } from "styled-components";

const reveal = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const zoomEffect = keyframes`
  0% { transform: scale(1.1); }
  100% { transform: scale(1.03); }
`;

const letterReveal = keyframes`
  from { 
    opacity: 0; 
    letter-spacing: 15px; 
    filter: blur(8px);
    transform: translateY(10px);
  }
  to { 
    opacity: 1; 
    letter-spacing: 6px; 
    filter: blur(0);
    transform: translateY(0);
  }
`;

const lineDraw = keyframes`
  from { width: 0; }
  to { width: 40px; }
`;

const SubVisual = ({ title, subTitle }) => {
  return (
    <VisualContainer>
      <BackgroundImage src="/images/Nav/skybg.jpg" />
      <Overlay />

      <Content>
        {/* <SubLabel>디에이치케이솔루션</SubLabel> */}

        <TitleWrapper>
          <div className="deco-line-left" />
          <Title>{title}</Title>
          <div className="deco-line-right" />
        </TitleWrapper>

        <Breadcrumb>
          <span className="home">{subTitle}</span>
          <span className="sep">{">"}</span>
          <span className="current">{title}</span>
        </Breadcrumb>
      </Content>

      <BottomEdge>
        <div className="white-bar" />
        <div className="accent-line" />
      </BottomEdge>
    </VisualContainer>
  );
};

export default SubVisual;

const VisualContainer = styled.div`
  width: 100%;
  height: 38vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-top: 80px;
  background-color: #000;
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  animation: ${zoomEffect} 8s ease-out infinite alternate;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
`;

const Content = styled.div`
  position: relative;
  z-index: 10;
  text-align: center;
  color: #fff;
`;

const SubLabel = styled.span`
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 4px;
  color: #00d2ff;
  margin-bottom: 15px;
  opacity: 0;
  animation: ${reveal} 1s ease-out forwards;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;

  .deco-line-left,
  .deco-line-right {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.4);
    animation: ${lineDraw} 1s ease-out 0.8s forwards;
    width: 0;
  }
`;

const Title = styled.h2`
  font-size: 3.2rem;
  font-weight: 800;
  letter-spacing: 6px;
  text-transform: uppercase;
  margin: 0;
  opacity: 0;
  animation: ${letterReveal} 1.2s cubic-bezier(0.2, 0, 0.2, 1) 0.3s forwards;
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const Breadcrumb = styled.div`
  font-size: 0.8rem;
  font-weight: 400;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.6);
  opacity: 0;
  animation: ${reveal} 1s ease-out 1s forwards;

  .sep {
    margin: 0 10px;
    color: rgba(255, 255, 255, 0.3);
  }
  .current {
    color: #fff;
    font-weight: 600;
  }
`;

const BottomEdge = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 15;

  .white-bar {
    width: 100%;
    height: 10px;
    background-color: #fff;
  }

  .accent-line {
    width: 100%;
    height: 2px;
    background-color: #00d2ff;
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
  }
`;
